import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from '../../../../contexts/StoreContext';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { DynamicModalProps } from '../DynamicModal.types';
import { useProductLogic } from 'src/hooks/use-product/useProduct.logic';
import { ROUTE_NAMES } from 'src/routes/_shared/routes.constants';
import { useRoute } from '@react-navigation/native';

export const ModalDelete = observer(
  ({
    type,
    dynamicModalVisible,
    dynamicModalLayer: { productToDelete, onPressDeleteProduct: onPressDelete, id },
  }: DynamicModalProps) => {
    const {
      project,
      i18n,
      dynamicModal: { closeModal },
    } = useStore();
    const { deleteProducts } = useProductLogic();
    const route = useRoute();
    const isEditorNew = [ROUTE_NAMES.EditorNew].includes(route?.name as ROUTE_NAMES);

    const onPressDeleteButton = async () => {
      const deletedProduct = productToDelete || project.activeProduct;
      if (deletedProduct) {
        isEditorNew
          ? deleteProducts({
              deletedProducts: [deletedProduct],
            })
          : project.removeProduct(deletedProduct.id);
      }
      closeModal();
      onPressDelete && onPressDelete();
      amplitude.trackEvent(AnalyticsEvents.personalize.deleteProductConfirmClick, {
        n_products: project.totalNumberOfProducts,
        action: 'confirm',
      });
    };

    const onAbortPressButton = async () => {
      closeModal();
      amplitude.trackEvent(AnalyticsEvents.personalize.deleteProductConfirmClick, {
        n_products: project.totalNumberOfProducts,
        action: 'cancel',
      });
    };

    return (
      <BaseModal
        testID={TestIDs.DELETE}
        modalIcon={
          <View style={{ width: 100, height: 100 }}>
            <Illustration name={ILLUSTRATION_NAMES.Delete} />
          </View>
        }
        title={i18n.t('customize:you-want-delete-frame')}
        description={i18n.t('customize:you-want-delete-frame-description')}
        discardText={i18n.t('customize:abort')}
        confirmText={i18n.t('customize:delete')}
        handleDiscard={onAbortPressButton}
        handleConfirm={onPressDeleteButton}
        onCloseOutside={closeModal}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
